import { CreditCardPaymentsPanel } from "@/components/organisms";

export const CreditCardPayments = () => {
  return (
    <div className="mb-12 flex flex-1 flex-col">
      <CreditCardPaymentsPanel />
    </div>
  );
};
